<template>
  <CompanyTemplate>
    <termsOfUse></termsOfUse>
  </CompanyTemplate>
</template>

<script>
import CompanyTemplate from '../template/CompanyTemplate'
import termsOfUse from '../components/TermsOfUse'
export default {
  components:{
    CompanyTemplate,
    termsOfUse
  }
};
</script>
<style scoped>
.background{
    min-height: 100vh;
    overflow: hidden;
    background-color: #F4F4F4 !important;
}

@media only screen and (max-width: 1087px) {
  .container{
    padding:5px
  }
} 
</style>